(ns entities.assets.events
  (:require
    [very.re-frame.core :as rf]
    [entities.assets.specs :as sp]
    [graphql.core :as qu]
    )
  )

(def path [:entities :assets])

(rf/reg-entity
  :assets
  {:get
   (fn [cfx]
     {:graphql {:gql (qu/assets)
                :success [:assets/fetched]
                :error [:assets/fetch-errored]
                :cancellable? true}})
   :patch
   (fn [cfx [{:keys [data]}]]
     {:graphql {:gql (qu/update-assets {:input {:assets data}})
                :success [:assets/updated]
                :error [:assets/update-errored]}})

   :spec/patch ::sp/patch
   })

(rf/reg-event-db
  :assets/fetched
  (rf/path path)
  (fn [_ [data]]
    (get-in data [:client :additional-assets])))

(rf/reg-event-db
  :assets/fetch-errored
  (rf/path path)
  (fn [_ [{:keys [data]}]]
    (get-in data [:client :additional-assets])))

(rf/reg-event-db
  :assets/updated
  (rf/path path)
  (fn [_ [data]]
    (:update-assets data)))

(rf/reg-event-db
  :assets/update-errored
  (rf/path path)
  (fn [_ [{:keys [data]}]]
    (:update-assets data)))
